import axios from 'axios';
import qs from 'qs';

const AutoChat = async (code , number , WeightDistance) => {
	let msg = WeightDistance > 0 ? 
	`مرحبا اني رهف

👩‍💼خبيرة تغذية من مرکز غصن البان للدكتور كرماني

📲حسب معلوماتك ، جان عندك ${WeightDistance} !!!

❌ هذا الوزن يشكل خطر جبير على صحتك، ويعرضك للأمراض المزمنة!
ومن واجبي الانساني ادليك على الطرق الآمنة للصحة والرشاقة.

 إذا تحب اشرحلك الطرق أكتبلي "نعم" او اتصل بيه ☺️

واني بخدمتكم`
	 : 
	`مرحبا اني رهف

👩‍💼خبيرة تغذية من مرکز غصن البان للدكتور كرماني

📲حسب معلوماتك ، جان عندك ${Math.abs(WeightDistance)} !!!

❌ هذا النقص يشكل خطر جبير على صحتك، ويعرضك للأمراض المزمنة!
ومن واجبي الانساني ادليك على الطرق الآمنة للصحة والرشاقة.

 إذا تحب اشرحلك الطرق أكتبلي "نعم" او اتصل بيه ☺️

واني بخدمتكم`

	let data = qs.stringify({
		'token': 'FnGoOlo6fdNVywgZwXrG6kv5xihsyCC435LpG2AegCim6rtSJYxDBv9bPK9HyhZT',
		'to': `${code}${number}`,
		'message': msg
	});

	let config = {
		method: 'post',
		maxBodyLength: Infinity,
		url: 'https://api.autochat.ir/api/v1/whatsapp/send-message',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		data: data
	};

	axios.request(config)
		.then((response) => {
			// toast.success('پیام شما برای کارشناس دکترکرمانی ثبت شد')
		})
		.catch((error) => {
			console.log(error);
		});
}
export default AutoChat